export const buyerFields = [
  {
    label: "First Name",
    name: "firstName",
    type: "text",
    placeholder: "First name",
    required: true,
    defaultValue: "",
  },
  {
    label: "Last Name",
    name: "lastName",
    type: "text",
    placeholder: "Last name",
    required: true,
    defaultValue: "",
  },
  {
    label: "Email Address",
    name: "email",
    type: "text",
    placeholder: "Email Address",
    required: true,
    defaultValue: "",
  },
  {
    label: "Middle Name",
    name: "middleInitials",
    type: "text",
    placeholder: "Middle name",
    required: false,
    defaultValue: "",
  },
  {
    label: "Phone",
    name: "phone",
    type: "text",
    placeholder: "Phone",
    required: true,
    defaultValue: "",
    maxLength:10
  },
  {
    label: "Address 1",
    name: "address1",
    type: "text",
    placeholder: "Address 1",
    required: true,
    defaultValue: "",
  },
  {
    label: "Address 2",
    name: "address2",
    type: "text",
    placeholder: "Address 2",
    required: false,
    defaultValue: "",
  },
  {
    label: "State",
    name: "stateId",
    type: "select",
    placeholder: "State",
    required: true,
    defaultValue: "",
  },
  {
    label: "City",
    name: "city",
    type: "text",
    placeholder: "City",
    required: true,
    defaultValue: "",
  },
  {
    label: "Zip",
    name: "zip",
    type: "text",
    placeholder: "Zip",
    required: true,
    defaultValue: "",
    maxLength:5
  },
];
export const businessFileds = [
   {
    label:"Name of the Business Entity",
    name: "company",
    type: "text",
    placeholder: "Name of the Business Entity",
    required: true,
    defaultValue: "",
    context:"business"
  }, 
  ...buyerFields
];

export const buyerAgent = [
  {
    label: "Agency Name",
    name: "company",
    type: "text",
    placeholder: "Agency Name",
    required: true,
    defaultValue: "",
    context:"agent"
  },
  ...buyerFields,
 
  {
    label: "Inidividual License State",
    name: "individualLicenseState",
    type: "select",
    placeholder: "Inidividual License State",
    required: true,
    defaultValue: "",
  },
  {
    label: "Inidividual License Number",
    name: "individualLicenseNumber",
    type: "text",
    placeholder: "Inidividual License Number",
    required: true,
    defaultValue: "",
  },
  {
    label: "Individual License Expiry Date",
    name: "licenseExpiryDate",
    type: "date",
    placeholder: "Individual License Expiry Date",
    required: true,
    defaultValue: "",
  },
   {
    label: "Corp License State",
    name: "corpLicenseState",
    type: "select",
    placeholder: "Corp License Select",
    required: false,
    defaultValue: "",
  },
  {
    label: "Corp License Number",
    name: "corpLicenseNumber",
    type: "text",
    placeholder: "Corp License Number",
    required: false,
    defaultValue: "",
  },
];
export const buyerWithAgentRole =[
  {
    label: "Agency Name",
    name: "company",
    type: "text",
    placeholder: "Agency Name",
    required: true,
    defaultValue: "",
    context:"agent"
  },
 ...buyerFields,
  {
    label: "Corp License State",
    name: "corpLicenseState",
    type: "select",
    placeholder: "Corp License Select",
    required: false,
    defaultValue: "",
  },
  {
    label: "Corp License Number",
    name: "corpLicenseNumber",
    type: "text",
    placeholder: "Corp License Number",
    required: false,
    defaultValue: "",
  },
  {
    label: "Inidividual License State",
    name: "individualLicenseState",
    type: "select",
    placeholder: "Inidividual License State",
    required: true,
    defaultValue: "",
  },{
    label: "Individual License Expiry Date",
    name: "licenseExpiryDate",
    type: "date",
    placeholder: "Individual License Expiry Date",
    required: true,
    defaultValue: "",
  },
  {
    label: "Inidividual License Number",
    name: "individualLicenseNumber",
    type: "text",
    placeholder: "Inidividual License Number",
    required: true,
    defaultValue: "",
  },
]

export const closingAgentTitle = [
    {
    label: "First Name",
    name: "firstName",
    type: "text",
    placeholder: "First name",
    required: true,
    defaultValue: "",
  },
  {
    label: "Email Address",
    name: "email",
    type: "text",
    placeholder: "Email Address",
    required: true,
    defaultValue: "",
  },
   {
    label: "Company",
    name: "company",
    type: "text",
    placeholder: "Company",
    required: true,
    defaultValue: "",
    context:"closingAgent"
  },
  {
    label: "Phone",
    name: "phone",
    type: "text",
    placeholder: "Phone",
    required: true,
    defaultValue: "",
    maxLength:10
  },
  {
    label: "Address One",
    name: "address1",
    type: "text",
    placeholder: "Address One",
    required: true,
    defaultValue: "",
  },
  {
    label: "Address Two",
    name: "address2",
    type: "text",
    placeholder: "Address Two",
    required: false,
    defaultValue: "",
  },
  {
    label: "State",
    name: "stateId",
    type: "select",
    placeholder: "State",
    required: true,
    defaultValue: "",
    context:"closingAgent"
  },
  {
    label: "City",
    name: "city",
    type: "text",
    placeholder: "City",
    required: true,
    defaultValue: "",
  },
  {
    label: "Zip",
    name: "zip",
    type: "text",
    placeholder: "Zip",
    required: true,
    defaultValue: "",
    maxLength:5
  },
]